const PARSE_OPTIONS = {
    negativeWithDecimal: /^-?\d*\.?\d*$/,
    withNegative: /^-?\d*$/,
    withDecimal: /^\d*\.?\d*$/,
    digitsOnly: /^\d*$/,
};
const isNumberInput = (value, parseOption = 'withDecimal') => PARSE_OPTIONS[parseOption].test(value);

export { isNumberInput };
//# sourceMappingURL=isNumberInput.js.map
